"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/SmallTimer.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var SmallTimer = function SmallTimer(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "line-icon",
    viewBox: "0 0 20.04 19.56"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "Small Timer Icon"), _react2.default.createElement("g", {
    className: "timer",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }, _react2.default.createElement("path", {
    d: "M10,19.56a9,9,0,1,1,9-9A9,9,0,0,1,10,19.56Zm0-16.5a7.51,7.51,0,1,0,7.5,7.51A7.51,7.51,0,0,0,10,3.06Z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 7
    },
    __self: undefined
  }), _react2.default.createElement("path", {
    d: "M0.74,4.78A0.74,0.74,0,0,1,.22,3.51L3.51,0.22A0.74,0.74,0,1,1,4.56,1.27L1.27,4.56A0.74,0.74,0,0,1,.74,4.78Z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 8
    },
    __self: undefined
  }), _react2.default.createElement("path", {
    d: "M19.3,4.78a0.74,0.74,0,0,1-.53-0.22L15.48,1.27A0.74,0.74,0,0,1,16.53.22l3.29,3.29A0.74,0.74,0,0,1,19.3,4.78Z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 9
    },
    __self: undefined
  }), _react2.default.createElement("path", {
    d: "M10,10.61a0.74,0.74,0,0,1-.74-0.74V5.4a0.74,0.74,0,1,1,1.49,0V9.86A0.74,0.74,0,0,1,10,10.61Z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 10
    },
    __self: undefined
  })));
};
exports.default = SmallTimer;